/**
 * Gated Content Modal with Gravity Form
 * 
 */

(function (window, document, $, undefined) {
	'use strict';

	window.gatedContent = {

		/**
		 * Initialize script behavior.
		 *
		 * @since 1.0.0
		 */
		init: function () {
			if (typeof global_data_layer === 'undefined') {
				return;
			}
			gatedContent.initVars();
			gatedContent.gatedLinks();
		},

		/**
		 * Setting and initializing all variables.
		 * @since 1.0.0
		 */
		initVars: function () {
			// Get Main Site Url & Countries Data

			gatedContent.$gatingType = global_data_layer.gatedContent;
			gatedContent.$site = global_data_layer.site.replace(/\/+$/, "");;
			gatedContent.$cookie = Cookies.get('allow_gated_content');
			gatedContent.$linkClass = $('.gated-content');
			gatedContent.$gravityModal = $('#gated-gravity-form-modal');
			gatedContent.$requestedContent = $('#requested-content');
			$('.gfield_select').selectpicker({});
		},

		/**
			* Gated Links Replace and Redirect Functions
			*
			* @since 1.0.0
			*/
		gatedLinks: function () {
			$(gatedContent.$linkClass).each(function () {
				var contentUrl = encodeURI($(this).attr('href')); // Get current url
				var newUrl = 'javascript:void(0)'; // Create new url
				$(this).data('url', contentUrl); // Set href value
				$(this).attr('href', newUrl); // Set href value
			});

			// Replace Gated Links on Hover/Focus
			$(gatedContent.$linkClass).bind("mouseenter focus mouseleave",
				function (event) {
					if (Cookies.get('allow_gated_content')) {
						$(this).attr({ 'href': $(this).data('url'), 'target': '_blank' });
					}
				}
			);

			$(gatedContent.$linkClass).click(function (e) {
				if (!Cookies.get('allow_gated_content')) {
					e.preventDefault();
					gatedContent.$gravityModal.modal('show');
				}
			});
		}
	};
	gatedContent.init();
})(window, document, jQuery);
